export default function NaturalLanguages() {
  return (
    <table>
      <tbody>
        <tr>
          <th colSpan={11}>Natural Slavic languages</th>
        </tr>
        <tr>
          <th>Language</th>
          <th>1</th>
          <th>2</th>
          <th>3</th>
          <th>4</th>
          <th>5</th>
          <th>6</th>
          <th>7</th>
          <th>8</th>
          <th>9</th>
          <th>10</th>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Proto-Slavic</td>
          <td>jedinŭ</td>
          <td>dŭva</td>
          <td>trĭje, tri</td>
          <td>četyre, četyri</td>
          <td>pętĭ</td>
          <td>šestĭ</td>
          <td>sedmĭ</td>
          <td>osmĭ</td>
          <td>devętĭ</td>
          <td>desętĭ</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Old Church Slavonic</td>
          <td>ѥдинъ</td>
          <td>дъва</td>
          <td>триѥ, три</td>
          <td>чєтырє, чєтыри</td>
          <td>пѧть</td>
          <td>шєсть</td>
          <td>сєдмь</td>
          <td>осмь</td>
          <td>дєвѧть</td>
          <td>дєсѧть</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Old Novgorodian</td>
          <td>одинъ</td>
          <td>дъва</td>
          <td>три(ѥ)</td>
          <td>цьтьри</td>
          <td>пѧть</td>
          <td>шєсть</td>
          <td>сємь</td>
          <td>осмь</td>
          <td>дєвѧть</td>
          <td>дєсѧть</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Old Russian</td>
          <td>одинъ</td>
          <td>дъва</td>
          <td>триѥ</td>
          <td>чєтырє</td>
          <td>пѧть</td>
          <td>шєсть</td>
          <td>сємь</td>
          <td>осмь</td>
          <td>дєвѧть</td>
          <td>дєсѧть</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Russian</td>
          <td>один</td>
          <td>два</td>
          <td>три</td>
          <td>четыре</td>
          <td>пять</td>
          <td>шесть</td>
          <td>семь</td>
          <td>восемь</td>
          <td>девять</td>
          <td>десять</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Belarusian</td>
          <td>
            адзін
            <br />
            adzin
          </td>
          <td>
            два
            <br />
            dva
          </td>
          <td>
            тры
            <br />
            try
          </td>
          <td>
            чатыры
            <br />
            čatyry
          </td>
          <td>
            пяць
            <br />
            piać
          </td>
          <td>
            шэсць
            <br />
            šesć
          </td>
          <td>
            сем
            <br />
            siem
          </td>
          <td>
            восем
            <br />
            vosiem
          </td>
          <td>
            дзевяць
            <br />
            dzieviać
          </td>
          <td>
            дзесяць
            <br />
            dziesiać
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Podlachian</td>
          <td>odin</td>
          <td>dva</td>
          <td>try</td>
          <td>štyry</td>
          <td>pjať</td>
          <td>šêsť</td>
          <td>siêm</td>
          <td>vôsim</td>
          <td>deveť</td>
          <td>deseť</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Ukrainian</td>
          <td>один</td>
          <td>два</td>
          <td>три</td>
          <td>чотири</td>
          <td>п'ять</td>
          <td>шiсть</td>
          <td>сiм</td>
          <td>вiсiм</td>
          <td>дев'ять</td>
          <td>десять</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Rusyn</td>
          <td>єден</td>
          <td>два</td>
          <td>три</td>
          <td>четыри</td>
          <td>пять</td>
          <td>шість</td>
          <td>сїм</td>
          <td>вусям</td>
          <td>девять</td>
          <td>десять</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Hutsul</td>
          <td>oden</td>
          <td>dva</td>
          <td>tre</td>
          <td>şterǐ</td>
          <td>pǐechǐ</td>
          <td>şîschǐ</td>
          <td>sim</td>
          <td>visim</td>
          <td>deawichǐ</td>
          <td>deasichǐ</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Lemko-Rusyn</td>
          <td>єден</td>
          <td>два</td>
          <td>три</td>
          <td>штыри, штырi</td>
          <td>пят</td>
          <td>шист</td>
          <td>сім</td>
          <td>вісем, осем</td>
          <td>девят</td>
          <td>десят</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Silesian</td>
          <td>jedyn</td>
          <td>dwa</td>
          <td>tři</td>
          <td>štyry</td>
          <td>pjyńć</td>
          <td>šeść</td>
          <td>śedym</td>
          <td>uoźym</td>
          <td>dźewjyńć</td>
          <td>dźeśyńć</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Polish</td>
          <td>jeden</td>
          <td>dwa</td>
          <td>trzy</td>
          <td>cztery</td>
          <td>pięć</td>
          <td>sześć</td>
          <td>siedem</td>
          <td>osiem</td>
          <td>dziewięć</td>
          <td>dziesięć</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Kashubian</td>
          <td>jeden</td>
          <td>dwa</td>
          <td>trzë</td>
          <td>sztërë</td>
          <td>piãc</td>
          <td>szesc</td>
          <td>sétmë</td>
          <td>òsmë</td>
          <td>dzewiãc</td>
          <td>dzesãc</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Polabian</td>
          <td>jadån</td>
          <td>dåvo</td>
          <td>tåri</td>
          <td>citĕr</td>
          <td>pąt</td>
          <td>sist</td>
          <td>sidĕm</td>
          <td>visĕm</td>
          <td>divąt</td>
          <td>disąt</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Lower Sorbian</td>
          <td>jaden</td>
          <td>dwa</td>
          <td>tśi</td>
          <td>styri</td>
          <td>pěś</td>
          <td>šesć</td>
          <td>sedym</td>
          <td>wósym</td>
          <td>źewjeś</td>
          <td>źaseś</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Upper Sorbian</td>
          <td>jedyn</td>
          <td>dwaj</td>
          <td>tři</td>
          <td>štyri</td>
          <td>pjeć</td>
          <td>šěsć</td>
          <td>sydom</td>
          <td>wosom</td>
          <td>dźewjeć</td>
          <td>dźesać</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Czech</td>
          <td>jeden</td>
          <td>dva</td>
          <td>tři</td>
          <td>čtyři</td>
          <td>pět</td>
          <td>šest</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devět</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovak</td>
          <td>jeden</td>
          <td>dva</td>
          <td>tri</td>
          <td>štyri</td>
          <td>päť</td>
          <td>šesť</td>
          <td>sedem</td>
          <td>osem</td>
          <td>deväť</td>
          <td>desať</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovene</td>
          <td>ena</td>
          <td>dva</td>
          <td>tri</td>
          <td>štiri</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Kajkavian Croatian</td>
          <td>jeden</td>
          <td>dva</td>
          <td>tri</td>
          <td>četri</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Čakavian Croatian</td>
          <td>eny</td>
          <td>duy</td>
          <td>tary</td>
          <td>cetyr</td>
          <td>pet</td>
          <td>šešt</td>
          <td>šedan</td>
          <td>ošan</td>
          <td>devet</td>
          <td>dešet</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Croatian/Bosnian</td>
          <td>jedan</td>
          <td>dva</td>
          <td>tri</td>
          <td>četiri</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedam</td>
          <td>osam</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Serbian</td>
          <td>
            један
            <br />
            jedan
          </td>
          <td>
            два
            <br />
            dva
          </td>
          <td>
            три
            <br />
            tri
          </td>
          <td>
            четири
            <br />
            četiri
          </td>
          <td>
            пет
            <br />
            pet
          </td>
          <td>
            шест
            <br />
            šest
          </td>
          <td>
            седам
            <br />
            sedam
          </td>
          <td>
            осам
            <br />
            osam
          </td>
          <td>
            девет
            <br />
            devet
          </td>
          <td>
            десет
            <br />
            deset
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Macedonian</td>
          <td>еден</td>
          <td>два</td>
          <td>три</td>
          <td>четири</td>
          <td>пет</td>
          <td>шест</td>
          <td>седум</td>
          <td>осум</td>
          <td>девет</td>
          <td>десет</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Bulgarian</td>
          <td>един</td>
          <td>два</td>
          <td>три</td>
          <td>четири</td>
          <td>пет</td>
          <td>шест</td>
          <td>седем</td>
          <td>осем</td>
          <td>девет</td>
          <td>десет</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Russenorsk</td>
          <td>odín</td>
          <td>tva</td>
          <td>tri</td>
          <td>sheteri</td>
          <td>pjôet</td>
          <td>sêst</td>
          <td>sêm</td>
          <td>vôsom</td>
          <td>divit</td>
          <td>desit</td>
        </tr>
        <tr>
          <th colSpan={11}>Constructed Slavic auxiliary languages</th>
        </tr>
        <tr>
          <th style={{ background: "var(--ifm-table-head-background)" }}>Language</th>
          <th>1</th>
          <th>2</th>
          <th>3</th>
          <th>4</th>
          <th>5</th>
          <th>6</th>
          <th>7</th>
          <th>8</th>
          <th>9</th>
          <th>10</th>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Ruski jezik <i>(Križanić)</i>
          </td>
          <td>једѐн</td>
          <td>два̂</td>
          <td>три̂</td>
          <td>чети́ри</td>
          <td>пêт</td>
          <td>шêст</td>
          <td>сéдем</td>
          <td>óсем</td>
          <td>дéвет</td>
          <td>дéсет</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Sveslavjanski jezik <i>(Ban)</i>
          </td>
          <td>jedin</td>
          <td>dva</td>
          <td>tri</td>
          <td>četiri</td>
          <td>pjat</td>
          <td>šest</td>
          <td>sedm</td>
          <td>osem</td>
          <td>devjat</td>
          <td>desjat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Vsjeslovianьskyь <i>(Bambas)</i>
          </td>
          <td>jedinъ</td>
          <td>dva</td>
          <td>tri</td>
          <td>četyri</td>
          <td>piatь</td>
          <td>šestь</td>
          <td>sedmь</td>
          <td>osmь</td>
          <td>dievjatь</td>
          <td>diesjatь</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Uzajemni Pravopis Slavjanski <i>(Majar)</i>
          </td>
          <td>једен</td>
          <td>два</td>
          <td>трі</td>
          <td>четірі</td>
          <td>пет</td>
          <td>шест</td>
          <td>седм</td>
          <td>осм</td>
          <td>девет</td>
          <td>десет</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Neuslawisch <i>(Hošek)</i>
          </td>
          <td>jeden</td>
          <td>dva</td>
          <td>tri</td>
          <td>četiri</td>
          <td>pjat</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devjat</td>
          <td>desat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Občeslovjanski <i>(Hošek)</i>
          </td>
          <td>odin</td>
          <td>dva</td>
          <td>tri</td>
          <td>četyre</td>
          <td>pjatj</td>
          <td>šestj</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devjatj</td>
          <td>desatj</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Slavina <i>(Konečný)</i>
          </td>
          <td>én</td>
          <td>dva</td>
          <td>tre</td>
          <td>čver</td>
          <td>pět</td>
          <td>šest</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devět</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Slovanština <i>(Kolkop)</i>
          </td>
          <td>prv</td>
          <td>vter</td>
          <td>tret</td>
          <td>чtvrt</td>
          <td>pet</td>
          <td>ſest</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Slavski <i>(Holý)</i>
          </td>
          <td>en</td>
          <td>dva</td>
          <td>tri</td>
          <td>četir</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>
            Slovan <i>(Zidek)</i>
          </td>
          <td>edna</td>
          <td>dva</td>
          <td>tri</td>
          <td>chtor</td>
          <td>piat</td>
          <td>shest</td>
          <td>sodum</td>
          <td>osum</td>
          <td>davet</td>
          <td>dasot</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Meždunarodski jazik</td>
          <td>йедин</td>
          <td>два</td>
          <td>три</td>
          <td>четири</td>
          <td>пет</td>
          <td>шест</td>
          <td>седем</td>
          <td>осем</td>
          <td>девет</td>
          <td>десет</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovio, Ruslavsk</td>
          <td>
            din
            <br />
            дин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            cxtir
            <br />
            чтир
          </td>
          <td>
            piat
            <br />
            пиат
          </td>
          <td>
            sxes
            <br />
            шест
          </td>
          <td>
            siem
            <br />
            сием
          </td>
          <td>
            vos
            <br />
            вос
          </td>
          <td>
            dev
            <br />
            дев
          </td>
          <td>
            des
            <br />
            дес
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovo</td>
          <td>
            jedin
            <br />
            ѥдин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            čtyri
            <br />
            чтыри
          </td>
          <td>
            pęť
            <br />
            пѧть
          </td>
          <td>
            šesť
            <br />
            шесть
          </td>
          <td>
            sedm
            <br />
            седм
          </td>
          <td>
            osm
            <br />
            осм
          </td>
          <td>
            devęť
            <br />
            девѧть
          </td>
          <td>
            desęť
            <br />
            десѧть
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Glagolica</td>
          <td>jeden</td>
          <td>dva</td>
          <td>tri</td>
          <td>četyri</td>
          <td>pět</td>
          <td>šest</td>
          <td>sedm</td>
          <td>osem</td>
          <td>devět</td>
          <td>desat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Proslava</td>
          <td>edin</td>
          <td>dva</td>
          <td>tri</td>
          <td>chetri</td>
          <td>pat</td>
          <td>shest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devat</td>
          <td>desat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Panslavien</td>
          <td>edin</td>
          <td>dva</td>
          <td>tri</td>
          <td>qetiri</td>
          <td>pet</td>
          <td>xest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Medjazik (Slavonske jazik)</td>
          <td>jedin</td>
          <td>dva</td>
          <td>tri</td>
          <td>c'etiri</td>
          <td>pjet</td>
          <td>s'est</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Sloviensk</td>
          <td>en</td>
          <td>dve</td>
          <td>tri</td>
          <td>s'tir</td>
          <td>pet</td>
          <td>s'es</td>
          <td>sem</td>
          <td>os</td>
          <td>dev</td>
          <td>des</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovianski</td>
          <td>
            jedin
            <br />
            једин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            četyri
            <br />
            четыри
          </td>
          <td>
            peť
            <br />
            петь
          </td>
          <td>
            šesť
            <br />
            шесть
          </td>
          <td>
            sedm
            <br />
            седм
          </td>
          <td>
            osm
            <br />
            осм
          </td>
          <td>
            deveť
            <br />
            деветь
          </td>
          <td>
            deseť
            <br />
            десеть
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slavenen (Noven Slovio)</td>
          <td>edin</td>
          <td>dva</td>
          <td>tri</td>
          <td>cetir</td>
          <td>pent</td>
          <td>xest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>nevent</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovioski</td>
          <td>
            jedin
            <br />
            једин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            četiri
            <br />
            четири
          </td>
          <td>
            piat
            <br />
            пиат
          </td>
          <td>
            šest
            <br />
            шест
          </td>
          <td>
            sedem
            <br />
            седем
          </td>
          <td>
            osem
            <br />
            осем
          </td>
          <td>
            devet
            <br />
            девет
          </td>
          <td>
            deset
            <br />
            десет
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slavski jezik</td>
          <td>jedan</td>
          <td>dva</td>
          <td>tri</td>
          <td>četiri</td>
          <td>pet</td>
          <td>šes</td>
          <td>sem</td>
          <td>osam</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Novoslovienskij</td>
          <td>
            iedin
            <br />
            іедин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            četyri
            <br />
            четыри
          </td>
          <td>
            piat
            <br />
            піат
          </td>
          <td>
            šest
            <br />
            шест
          </td>
          <td>
            sedm
            <br />
            седм
          </td>
          <td>
            osm
            <br />
            осм
          </td>
          <td>
            deviat
            <br />
            девіат
          </td>
          <td>
            desiat
            <br />
            десіат
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Naučny Medžuslovjanski</td>
          <td>jedin</td>
          <td>dva</td>
          <td>tri</td>
          <td>četyri</td>
          <td>pęť</td>
          <td>šesť</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devęť</td>
          <td>desęť</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovianto</td>
          <td>
            jedin
            <br />
            једин
          </td>
          <td>
            dva
            <br />
            два
          </td>
          <td>
            tri
            <br />
            три
          </td>
          <td>
            četiri
            <br />
            четири
          </td>
          <td>
            pet
            <br />
            пет
          </td>
          <td>
            šest
            <br />
            шест
          </td>
          <td>
            sedem
            <br />
            седем
          </td>
          <td>
            osem
            <br />
            осем
          </td>
          <td>
            devet
            <br />
            девет
          </td>
          <td>
            deset
            <br />
            десет
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Prostoslovjanski</td>
          <td>jedin</td>
          <td>dva</td>
          <td>tri</td>
          <td>četiri</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Rusanto</td>
          <td>odin</td>
          <td>dva</td>
          <td>tri</td>
          <td>cxetire</td>
          <td>piat</td>
          <td>sxest</td>
          <td>sem</td>
          <td>vosem</td>
          <td>deviat</td>
          <td>desiat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovko</td>
          <td>edno</td>
          <td>dvi</td>
          <td>tri</td>
          <td>chotiri</td>
          <td>peti</td>
          <td>shesti</td>
          <td>sedmi</td>
          <td>osedmi</td>
          <td>deveti</td>
          <td>deseti</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Venedčina</td>
          <td>jedenj</td>
          <td>dva</td>
          <td>tri</td>
          <td>četri</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Nowoslownica</td>
          <td>једен</td>
          <td>два</td>
          <td>три</td>
          <td>четыри</td>
          <td>пѣт</td>
          <td>шест</td>
          <td>седем</td>
          <td>осем</td>
          <td>девѣт</td>
          <td>десѣт</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slovenska nova lingvafranka (SNL)</td>
          <td>jeden</td>
          <td>dva</td>
          <td>tri</td>
          <td>czeter</td>
          <td>pet</td>
          <td>szest</td>
          <td>sedem</td>
          <td>vosem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <th colSpan={11}>Fictional North-Slavic languages</th>
        </tr>
        <tr>
          <th>Language</th>
          <th>1</th>
          <th>2</th>
          <th>3</th>
          <th>4</th>
          <th>5</th>
          <th>6</th>
          <th>7</th>
          <th>8</th>
          <th>9</th>
          <th>10</th>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Sevorian</td>
          <td>iedøn</td>
          <td>dvaa</td>
          <td>trii</td>
          <td>sxøtir</td>
          <td>pet</td>
          <td>sxest</td>
          <td>sedøm</td>
          <td>osøm</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Vozgian (Gŭor vŭozgašchai)</td>
          <td>
            іђін
            <br />
            iðin
          </td>
          <td>
            дўа
            <br />
            dŭa
          </td>
          <td>
            ћрі
            <br />
            þri
          </td>
          <td>
            чядир
            <br />
            čädyr
          </td>
          <td>
            пенћ
            <br />
            penþ
          </td>
          <td>
            шећ
            <br />
            šeþ
          </td>
          <td>
            седем
            <br />
            sedem
          </td>
          <td>
            oсем
            <br />
            osem
          </td>
          <td>
            дўенћ
            <br />
            dŭenþ
          </td>
          <td>
            десенћ
            <br />
            desenþ
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Našica (old)</td>
          <td>edët</td>
          <td>deva</td>
          <td>trie</td>
          <td>cetire</td>
          <td>pet</td>
          <td>sest</td>
          <td>sedm</td>
          <td>osm</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Nasika (new)</td>
          <td>inu</td>
          <td>ta</td>
          <td>tiirä</td>
          <td>cëtura</td>
          <td>pëncëti</td>
          <td>sësti</td>
          <td>sëttomi</td>
          <td>ostomi</td>
          <td>teenti</td>
          <td>tesemti</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Seversk</td>
          <td>jedan</td>
          <td>dva</td>
          <td>tre</td>
          <td>štåre</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedam</td>
          <td>osam</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Mrezisk</td>
          <td>jedan</td>
          <td>deva</td>
          <td>tera</td>
          <td>štara</td>
          <td>pynta</td>
          <td>šasta</td>
          <td>sedam</td>
          <td>osam</td>
          <td>devet</td>
          <td>desat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slavëni</td>
          <td>gedan</td>
          <td>deva</td>
          <td>tera</td>
          <td>štara</td>
          <td>pinta</td>
          <td>šasta</td>
          <td>sedam</td>
          <td>osam</td>
          <td>devet</td>
          <td>desat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Slavisk</td>
          <td>gidan</td>
          <td>déva</td>
          <td>tera</td>
          <td>štara</td>
          <td>pinta</td>
          <td>šasta</td>
          <td>sédam</td>
          <td>ósam</td>
          <td>dévet</td>
          <td>désat</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Ijslova</td>
          <td>jijn</td>
          <td>dvis</td>
          <td>tris</td>
          <td>sjöris</td>
          <td>pjem</td>
          <td>shes</td>
          <td>sjödem</td>
          <td>ästem</td>
          <td>nivam</td>
          <td>disam</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Skuodian</td>
          <td>jeriino</td>
          <td>dovaa</td>
          <td>trije/trii</td>
          <td>t'ietiiri</td>
          <td>piente</td>
          <td>sieste</td>
          <td>siende</td>
          <td>uosme</td>
          <td>dieviente</td>
          <td>diesiente</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Novegradian</td>
          <td>
            едене
            <br />
            iédene
          </td>
          <td>
            дова
            <br />
            dóva
          </td>
          <td>
            три
            <br />
            trí
          </td>
          <td>
            цетире
            <br />
            cétire
          </td>
          <td>
            пети
            <br />
            péti
          </td>
          <td>
            шести
            <br />
            śésti
          </td>
          <td>
            шеньи
            <br />
            śénji
          </td>
          <td>
            ошми
            <br />
            óśmi
          </td>
          <td>
            девити
            <br />
            déviti
          </td>
          <td>
            дешити
            <br />
            déśiti
          </td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Onegian (Onegskoi ezeik)</td>
          <td>edin</td>
          <td>dva</td>
          <td>tri</td>
          <td>četeire</td>
          <td>pet</td>
          <td>šest</td>
          <td>sedem</td>
          <td>osem</td>
          <td>devet</td>
          <td>deset</td>
        </tr>
        <tr>
          <td style={{ background: "var(--ifm-table-head-background)" }}>Rothian (Rodzku jezuk)</td>
          <td>jödin</td>
          <td>dva</td>
          <td>tri</td>
          <td>ššetüri</td>
        </tr>
      </tbody>
    </table >
  )
}
